import type { NavigationItem } from '@/types/layout.types';
import { usePointerActivation } from '@/hooks';
import { cn } from '@/utils';

interface LegacyMobileBottomNavItemProps {
	item: NavigationItem;
	isActive: boolean;
	onNavigate: (path: string) => void;
}

export function LegacyMobileBottomNavItem({
	item,
	isActive,
	onNavigate,
}: LegacyMobileBottomNavItemProps) {
	const pointerProps = usePointerActivation(() => onNavigate(item.href!));

	return (
		<button
			type="button"
			{...pointerProps}
			className="flex grow basis-0 flex-col items-center justify-center pt-1"
		>
			<div className="flex size-8 items-center justify-center">
				<item.icon
					className={cn(
						'size-6 transition-[color,filter] duration-200',
						isActive
							? 'text-blue-custom-2 filter-[drop-shadow(0_0_6px_rgba(38,103,255,0.55))_drop-shadow(0_0_12px_rgba(38,103,255,0.3))]'
							: 'text-[#626366]'
					)}
				/>
			</div>
			<span
				className={cn(
					'mt-1 text-[10px] font-medium transition-all duration-200',
					isActive
						? 'scale-100 text-[#FAFAFA] opacity-100'
						: 'pointer-events-none scale-95 opacity-0'
				)}
			>
				{item.tabName}
			</span>
		</button>
	);
}
